/**
 * Utilitário para copiar texto para a área de transferência
 * com fallback para ambientes onde a Clipboard API está bloqueada (ex: iframes)
 */

export const copyToClipboard = async (text) => {
  // Método 1: Clipboard API moderna (funciona na maioria dos browsers modernos)
  try {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    console.warn('Clipboard API falhou:', err.message);
  }
  
  // Método 2: execCommand com textarea (fallback para browsers antigos e iframes)
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Estilos para evitar scroll e ficar invisível
    textArea.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 2em;
      height: 2em;
      padding: 0;
      border: none;
      outline: none;
      box-shadow: none;
      background: transparent;
      font-size: 16px;
    `;
    
    document.body.appendChild(textArea);
    
    // iOS específico
    const isiOS = navigator.userAgent.match(/ipad|iphone/i);
    if (isiOS) {
      textArea.contentEditable = 'true';
      textArea.readOnly = false;
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.focus();
      textArea.select();
    }
    
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (success) {
      return true;
    }
  } catch (err) {
    console.error('execCommand falhou:', err);
  }
  
  // Método 3: Prompt manual (último recurso)
  try {
    window.prompt('Copie o texto abaixo (Ctrl+C):', text);
    return true; // Assumimos que o usuário copiou
  } catch (err) {
    console.error('Prompt falhou:', err);
  }
  
  return false;
};

export default copyToClipboard;
